import { dataAccessEnvironment } from './data-access-environment';

export class FleetJwtAuthHeaders {
  readonly Authorization: string;

  constructor() {
    this.Authorization = `Bearer ${dataAccessEnvironment.fleetJwt}`;
  }
}
